import React from "react";
import {
  Button,
  Tooltip,
  IconButton,
  Checkbox,
  FormControlLabel,
  Badge,
  Box,
} from "@mui/material";

const Botones = ({ botones }) => {
  return (
    <>
      {botones.map((itemBoton) => {
        const {
          tooltip,
          funcion,
          disabled,
          Icon,
          color,
          id,
          ocultar,
          tipo,
          variante,
          size,
          texto,
          sx,
          estado,
          submit,
          disableElevation,
          colorbadge,
        } = itemBoton;
        if (ocultar) {
          return null;
        }

        return (
          <>
            {tipo === "icono" ? (
              <>
                {texto ? (
                  <>
                    <Box sx={{ pl: 2 }}>
                      <Badge
                        badgeContent={texto}
                        color={colorbadge ?? "primary"}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      ></Badge>
                      <Tooltip
                        title={tooltip}
                        key={id}
                        followCursor
                        placement="top-start"
                      >
                        <IconButton
                          sx={sx}
                          disabled={disabled}
                          onClick={(e) => funcion(e)}
                          type={submit ? "submit" : "button"}
                          onSubmit={(e) => {
                            e?.preventDefault();
                            funcion(e);
                          }}
                        >
                          {Icon && (
                            <Icon
                              disabled={disabled}
                              color={disabled ? "inherit" : color}
                              fontSize={size}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </>
                ) : (
                  <Tooltip
                    title={tooltip}
                    key={id}
                    followCursor
                    placement="top-start"
                  >
                    <IconButton
                      sx={sx}
                      disabled={disabled}
                      onClick={(e) => funcion(e)}
                      type={submit ? "submit" : "button"}
                      onSubmit={(e) => {
                        e.preventDefault();
                        funcion(e);
                      }}
                    >
                      {Icon && (
                        <Icon
                          disabled={disabled}
                          color={disabled ? "inherit" : color}
                          fontSize={size}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
              </>
            ) : null}
            {tipo === "boton" ? (
              <Tooltip title={tooltip} key={id}>
                <Button
                  type={submit ? "submit" : "button"}
                  onSubmit={() => funcion()}
                  sx={sx}
                  size={size}
                  variant={variante}
                  color={color}
                  disabled={disabled}
                  startIcon={<Icon />}
                  onClick={() => funcion()}
                  disableElevation={disableElevation}
                >
                  {texto}
                </Button>
              </Tooltip>
            ) : null}

            {tipo === "check" ? (
              <Tooltip
                title={tooltip}
                key={id}
                followCursor
                placement="top-start"
              >
                <FormControlLabel
                  sx={{ marginLeft: ".5rem" }}
                  control={
                    <Checkbox
                      disabled={disabled}
                      onChange={(e) => funcion(e)}
                      sx={sx}
                      size={size}
                      value="ACTIVO"
                      checked={estado}
                      color={color}
                    />
                  }
                />
              </Tooltip>
            ) : null}
          </>
        );
      })}
    </>
  );
};

export default Botones;
